module.exports = __webpack_public_path__ + "img/bj_3.cc6bd929.png";